<div class="grid p-fluid">
   <div class="col-12">
      <p-tabView [scrollable]="true">
         <p-tabPanel *ngFor="let section of sections" header="{{section.Title}}">
            <app-helper-section [section]="section" [controller]="controller"></app-helper-section>
         </p-tabPanel>
      </p-tabView>
   </div>
</div>
